declare namespace $ {

	type $bog_music_track__key_bog_music_tracks_1 = $mol_type_enforce<
		ReturnType< $bog_music_tracks['track_key'] >
		,
		ReturnType< $bog_music_track['key'] >
	>
	type $bog_music_track__current_bog_music_tracks_2 = $mol_type_enforce<
		ReturnType< $bog_music_tracks['track_current'] >
		,
		ReturnType< $bog_music_track['current'] >
	>
	type $bog_music_track__play_bog_music_tracks_3 = $mol_type_enforce<
		ReturnType< $bog_music_tracks['track_play'] >
		,
		ReturnType< $bog_music_track['play'] >
	>
	type $bog_music_track__archive_mode_bog_music_tracks_4 = $mol_type_enforce<
		ReturnType< $bog_music_tracks['archive_mode'] >
		,
		ReturnType< $bog_music_track['archive_mode'] >
	>
	type $bog_music_track__can_drag_bog_music_tracks_5 = $mol_type_enforce<
		ReturnType< $bog_music_tracks['track_can_drag'] >
		,
		ReturnType< $bog_music_track['can_drag'] >
	>
	type $bog_music_track__drag_start_bog_music_tracks_6 = $mol_type_enforce<
		ReturnType< $bog_music_tracks['track_drag_start'] >
		,
		ReturnType< $bog_music_track['drag_start'] >
	>
	type $bog_music_track__drop_here_bog_music_tracks_7 = $mol_type_enforce<
		ReturnType< $bog_music_tracks['track_drop_here'] >
		,
		ReturnType< $bog_music_track['drop_here'] >
	>
	type $bog_music_track__archive_bog_music_tracks_8 = $mol_type_enforce<
		ReturnType< $bog_music_tracks['track_archive'] >
		,
		ReturnType< $bog_music_track['archive'] >
	>
	type $bog_music_track__restore_bog_music_tracks_9 = $mol_type_enforce<
		ReturnType< $bog_music_tracks['track_restore'] >
		,
		ReturnType< $bog_music_track['restore'] >
	>
	type $bog_music_track__delete_forever_bog_music_tracks_10 = $mol_type_enforce<
		ReturnType< $bog_music_tracks['track_delete'] >
		,
		ReturnType< $bog_music_track['delete_forever'] >
	>
	type $bog_music_track__demote_bog_music_tracks_11 = $mol_type_enforce<
		ReturnType< $bog_music_tracks['track_demote'] >
		,
		ReturnType< $bog_music_track['demote'] >
	>
	export class $bog_music_tracks extends $mol_list {
		track_key( id: any): string
		track_current( id: any): boolean
		track_play( id: any, next?: any ): any
		track_can_drag( id: any): boolean
		track_drag_start( id: any, next?: any ): any
		track_drop_here( id: any, next?: any ): any
		track_archive( id: any, next?: any ): any
		track_restore( id: any, next?: any ): any
		track_delete( id: any, next?: any ): any
		track_demote( id: any, next?: any ): any
		Track( id: any): $bog_music_track
		track_rows( ): readonly(any)[]
		track_keys( ): readonly(any)[]
		current_key( ): string
		play_key( next?: any ): any
		archive_mode( ): boolean
		reorder_to( next?: any ): any
		archive_key( next?: any ): any
		restore_key( next?: any ): any
		delete_key( next?: any ): any
		demote_key( next?: any ): any
		rows( ): ReturnType< $bog_music_tracks['track_rows'] >
	}
	
}

//# sourceMappingURL=tracks.view.tree.d.ts.map